import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environmentConfigFactory } from '@shared/factories/environment-config.factory';
import { environment } from '@car-read/environments/environment';
import { commonRoutes } from '@shared/consts/common-routes';

const routesPath = environmentConfigFactory(environment).routes;
const routes: Routes = [
  ...commonRoutes(routesPath),
  {
    path: '',
    loadChildren: () => import('./pages/page.module').then((m) => m.PageModule),
  },
  {
    path: '**',
    redirectTo: `/${routesPath['not-found']}`,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
